

import { bl_fi_sales_commission_report_hdr_gendoc_hdr_link_RowClass } from '../../dbschema/bl_fi_sales_commission_report_hdr_gendoc_hdr_link.model';
import { BaseContainerModel } from '../base-container.model';

export class SalesCommissionReportHdrToGendocHdrLinkContainerModel extends BaseContainerModel {
    bl_fi_sales_commission_report_hdr_gendoc_hdr_link: bl_fi_sales_commission_report_hdr_gendoc_hdr_link_RowClass = new bl_fi_sales_commission_report_hdr_gendoc_hdr_link_RowClass();
}
